import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import SelectDropdown  from 'flarum/common/components/SelectDropdown';
import Stream from 'flarum/common/utils/Stream';
import { debounce } from 'flarum/common/utils/throttleDebounce';

export default class GlobalApplicationProlongModal extends Modal {
    oninit(vnode) {
        super.oninit(vnode);

        this.application = this.attrs.application;
        this.applications = [];
        this.isLoadingPage = true;
        this.choosedUnitOfTime = 'minute';

        app.store.all('applications').filter((application) => application.canView()).forEach((application) => {
            this.applications[application.id()] = {
                id: application.id(),
                name: application.name(),
                active: Stream(this.application.id() === application.id())
            };
        });

        this.isLoadingPage = false;
        m.redraw();
    }

    className() {
        return 'GlobalApplicationProlongModal Modal--small';
    }

    title() {
        return app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.global_control.grid.prolong_model.label');
    }

    content() {
        const applications = this.applications;

        return (
            <div className="Modal-body">
                <div className="Form">
                    <div className="GlobalApplicationProlongModal">
                        <div className="Form-group ApplicationsGroup">
                            <label>{app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.global_control.grid.prolong_model.applications')}</label>
                            <div>
                            {
                                applications.map((application) => (
                                    <label className="checkbox">
                                        <input
                                            type="checkbox"
                                            bidi={application.active}
                                            disabled={this.application.id() === application.id}
                                        />
                                        { application.name }
                                    </label>
                                ))
                            }
                            </div>
                        </div>
                        <div className="Form-group">
                            <label>{app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.global_control.grid.prolong_model.time.label')}</label>
                            <div className="ProlongGroup">
                                <input id="number" type="number" className="FormControl" placeholder={app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.global_control.grid.prolong_model.time.placeholder')} required />
                                <SelectDropdown
                                    icon="fas fa-ellipsis-v"
                                    buttonClassName="Button Button--primary"
                                    required
                                >
                                    {
                                        ['minute','hour','day','week','month'].map((option) => (
                                            <Button active={this.choosedUnitOfTime === option} onclick={() => this.choosedUnitOfTime = option }>
                                                {app.translator.trans(`xtreh-phoenix.forum.cheatpanel.grid.global_control.grid.prolong_model.time.${option}`)}
                                            </Button>
                                        ))
                                    }
                                </SelectDropdown>
                            </div>
                        </div>
                        <Button className="Button Button--primary" loading={this.loading} type="submit">
                            { app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.global_control.grid.prolong_model.button') }
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    onsubmit(e) {
        e.preventDefault();

        this.loading = true;

        const timeToSeconds = {
            minute: 60,
            hour: 3600,
            day: 86400,
            week: 604800,
            month: 2592000
        };

        const appIds = this.applications
            .filter((application) => application.active() && application.id !== this.application.id())
            .map((application) => application.id);

        app.request({
            method: 'PATCH',
            url: app.forum.attribute('apiUrl') + '/applications/global',
            params: { application: this.application.id(), code: 1, value: timeToSeconds[this.choosedUnitOfTime] * $('#number').val(), param: appIds },
            errorHandler: this.onerror.bind(this)
        }).then(() => {
            let alert = app.alerts.show({ dismissible: true, type: 'success' }, app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.global_control.grid.success_prolong_changed'));
            debounce(2500, () => app.alerts.dismiss(alert))();
            this.loading = false;
            m.redraw();
        }).catch(() => {
            this.loading = false;
            m.redraw();
        });
    }
}
